import {
  House, ChartLineUp, Megaphone, CalendarBlank, RocketLaunch, Camera, Wallet,
  Sparkle, InstagramLogo, Images, PushPin, Globe, Target, EnvelopeSimple,
  Ticket, Handshake, Star, UsersThree, AddressBook, Newspaper, CalendarStar,
  ChartBar, Brain, Binoculars, FileText, CheckSquare, SealCheck, Bell,
  ChatCircleDots, Gear,
} from "@phosphor-icons/react";

export const NAV_GROUPS = [
  {
    label: "Plan",
    items: [
      { key: "home", label: "Home", path: "/", icon: House },
      { key: "dashboard", label: "Marketing Dashboard", path: "/dashboard", icon: ChartLineUp },
      { key: "campaigns", label: "Campaigns", path: "/campaigns", icon: Megaphone },
      { key: "calendar", label: "Marketing Calendar", path: "/calendar", icon: CalendarBlank },
      { key: "launches", label: "Product Launches", path: "/launches", icon: RocketLaunch },
      { key: "photoshoots", label: "Photoshoots", path: "/photoshoots", icon: Camera },
      { key: "budgets", label: "Budget", path: "/budgets", icon: Wallet },
    ],
  },
  {
    label: "Create",
    items: [
      { key: "studio", label: "AI Content Studio", path: "/studio", icon: Sparkle },
      { key: "social", label: "Social Media", path: "/social", icon: InstagramLogo },
      { key: "assets", label: "Digital Assets", path: "/assets", icon: Images },
      { key: "inspiration", label: "Inspiration Boards", path: "/inspiration", icon: PushPin },
      { key: "seo", label: "Website & SEO", path: "/seo", icon: Globe },
    ],
  },
  {
    label: "Promote",
    items: [
      { key: "ads", label: "Paid Advertising", path: "/ads", icon: Target },
      { key: "messaging", label: "Email, WhatsApp & SMS", path: "/messaging", icon: EnvelopeSimple },
      { key: "promotions", label: "Promotions & Coupons", path: "/promotions", icon: Ticket },
      { key: "affiliates", label: "Affiliate Marketing", path: "/affiliates", icon: Handshake },
      { key: "influencers", label: "Influencers", path: "/influencers", icon: Star },
    ],
  },
  {
    label: "Relationships",
    items: [
      { key: "segments", label: "Customer Segments", path: "/segments", icon: UsersThree },
      { key: "crm", label: "Collaboration CRM", path: "/crm", icon: AddressBook },
      { key: "pr", label: "PR & Media", path: "/pr", icon: Newspaper },
      { key: "events", label: "Events & Exhibitions", path: "/events", icon: CalendarStar },
    ],
  },
  {
    label: "Analyse",
    items: [
      { key: "analytics", label: "Analytics & Attribution", path: "/analytics", icon: ChartBar },
      { key: "insights", label: "AI Insights", path: "/insights", icon: Brain },
      { key: "competitors", label: "Competitor Intelligence", path: "/competitors", icon: Binoculars },
      { key: "reports", label: "Reports", path: "/reports", icon: FileText },
    ],
  },
  {
    label: "Manage",
    items: [
      { key: "tasks", label: "Tasks", path: "/tasks", icon: CheckSquare },
      { key: "approvals", label: "Approvals", path: "/approvals", icon: SealCheck },
      { key: "notifications", label: "Notifications", path: "/notifications", icon: Bell },
      { key: "team", label: "Team Collaboration", path: "/team", icon: ChatCircleDots },
      { key: "settings", label: "Settings", path: "/settings", icon: Gear },
    ],
  },
];

export const ALL_NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);
